import React from 'react';
import { Table } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { array, number } from 'prop-types';
import TicketsListItem from './TicketsListItem';

const propTypes = {
  tickets: array.isRequired,
  total: number.isRequired,
};

const defaultProps = {
  tickets: [],
  total: 0,
};

const TicketsList = ({ tickets, toggleTicketModal }) => (
  <Table className="tickets-list no-margin" bordered responsive>
    <thead>
      <tr>
        <th>
          <FormattedMessage id="tickets.id" defaultMessage="ID" />
        </th>
        <th>
          <FormattedMessage id="tickets.created" defaultMessage="Created" />
        </th>
        <th>
          <FormattedMessage id="tickets.title" defaultMessage="Title" />
        </th>
        <th>
          <FormattedMessage id="tickets.status" defaultMessage="Status" />
        </th>
        <th>
          <FormattedMessage id="tickets.answers" defaultMessage="Answers" />
        </th>
      </tr>
    </thead>
    <tbody>
      {tickets.length > 0 &&
        tickets.map((ticket) => (
          <TicketsListItem
            key={ticket.id}
            ticket={ticket}
            toggleTicketModal={() => toggleTicketModal(ticket.id)}
          />
        ))}
    </tbody>
  </Table>
);

TicketsList.propTypes = propTypes;
TicketsList.defaultProps = defaultProps;

export default TicketsList;
